export interface BatchOnShelfReserveListRequest {
  dateFrom: string | null
  dateTo: string | null
  holdingBranchCode: string
  outputCondition: string
  batchType: string
}

export function BatchOnShelfReserveListRequestToJSON(
  value: BatchOnShelfReserveListRequest
): any {
  return {
    date_from: value.dateFrom,
    date_to: value.dateTo,
    holding_branch_code: value.holdingBranchCode,
    output_condition: value.outputCondition,
    batch_type: value.batchType
  }
}
